import { MultiSelect } from "@mantine/core";
import React, { useState } from "react";
import { Alert, Card, CardBody, Col, FormFeedback, Input, Label, Row, Spinner } from "reactstrap";
import { getAssignationManagementResidueFinalDestinationList } from "../../../../helpers/residue/backend_helper";
import { useEffect } from "react";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useDispatch } from "react-redux";
import { getResidueConversionList } from "../../../../slices/thunks";
import { first } from "lodash";

const ConversionSection = ({
    key,
    dataResidue,
    dataUnitMeasurement,
    dataResidueConversionList,
    handleDataResidueConversionList
}) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [dataResidueConversion, setDataResidueConversion] = useState(null);
    const [firstChange, setFirstChange] = useState(false);
    
    const getDataConversionResidue = async () => {
        setIsLoading(true);

        try {
            const response = await dispatch(getResidueConversionList({
                residue_id: dataResidue._id,
                unit_measurement_id: dataUnitMeasurement._id
            })).unwrap();

            console.log('response get residue conversion', response)
            if (response){
                const residueConversion = response[0];
                setDataResidueConversion(residueConversion);
            }

            setIsLoading(false);
        } catch (err){
            setIsLoading(false);
            console.error('Error:', err);
        }
    };

    // validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
            unitMeasurement: '',
            kilogram: null
		},
		validationSchema: Yup.object({
            kilogram: Yup.number()
                .typeError('debe ser un número entero')
                .required('Campo requerido'),
		}),
		onSubmit: values => {
            const newDataResidueConversion = {
                _id: (
                    dataResidueConversion
                        ? dataResidueConversion._id
                        : null
                ),
                residue_id: dataResidue?._id || null,
                unit_measurement_id: dataUnitMeasurement?._id || null,
                kilogram: values.kilogram
            }
            handleUpdateDataResidueConversionList(newDataResidueConversion);
		},
	});

    function handleUpdateDataResidueConversionList(newResidueConversion){
        let dataResidueConversionListToUpdate = dataResidueConversionList;

        const index = dataResidueConversionListToUpdate.findIndex(
            item => item.unit_measurement_id === newResidueConversion.unit_measurement_id
        );

        if(dataResidueConversionListToUpdate[index]){
            dataResidueConversionListToUpdate[index] = {
                ...dataResidueConversionListToUpdate[index],
                ...newResidueConversion
            }
        }else{
            dataResidueConversionListToUpdate.push(
                newResidueConversion
            );
        }
        console.log('dataResidueConversionlist: ', dataResidueConversionListToUpdate)
        handleDataResidueConversionList(dataResidueConversionListToUpdate);
    }

    // function handleDeleteItemDataResidueConversionList(unitMeasurement){
    //     let dataResidueConversionListToUpdate = dataResidueConversionList;

    //     dataResidueConversionListToUpdate = dataResidueConversionListToUpdate.filter(
    //         item => item.unit_measurement_id != unitMeasurement
    //     );
    //     handleDataResidueConversionList(dataResidueConversionListToUpdate);
    // }

    useEffect(() => {
        if(dataResidue){
            getDataConversionResidue();
        }
    }, [dataResidue]);

    useEffect(() => {
        if(dataResidueConversion){
            validation.setFieldValue('kilogram', dataResidueConversion.kilogram);
        }
    }, [dataResidueConversion]);

    useEffect(()=> {
        if(dataUnitMeasurement){
            validation.setFieldValue('unitMeasurement', dataUnitMeasurement.name);
        }
    }, [dataUnitMeasurement]);

    useEffect(() => {
        console.log(firstChange);
        if(validation.values['kilogram'] && firstChange){
            validation.handleSubmit();
        }
        if(validation.values['kilogram'] == 0 && firstChange){
            handleUpdateDataResidueConversionList({
                ...(dataResidueConversion && {
                    _id: dataResidueConversion._id
                }),
                residue_id: dataResidue._id,
                unit_measurement_id: dataUnitMeasurement._id,
                kilogram: 0
            });
            // handleDeleteItemDataResidueConversionList(dataUnitMeasurement._id);
        }
    }, [validation.values['kilogram'], firstChange]);

    return (
        <React.Fragment>
            <Card className="border">
                <CardBody>
                    {isLoading ? (
                        <Alert color='primary'>
                            <Spinner size='sm' className='me-2' />
                            Cargando datos, por favor espere...
                        </Alert>
                    ) : null}
                    <Row>
                        <Col lg={6}>
                            <Label for='unitMeasurement' className='form-label'>
                                Unidad de Medida
                            </Label>
                            <Input
                                name='unitMeasurement'
                                id='unitMeasurement'
                                className='form-control'
                                placeholder=''
                                type='text'
                                validate={{ required: { value: true } }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.unitMeasurement || ''}
                                invalid={
                                    validation.touched.unitMeasurement &&
                                        validation.errors.unitMeasurement
                                        ? true
                                        : false
                                }
                                disabled={true}
                            />
                            {
                                validation.touched.unitMeasurement &&
                                    validation.errors.unitMeasurement ? (
                                    <FormFeedback type='invalid'>
                                        {validation.errors.unitMeasurement}
                                    </FormFeedback>
                                ) : null
                            }
                        </Col>
                        
                        <Col lg={6}>
                            <Label for='kilogram' className='form-label'>
                                Kilogramo
                            </Label>
                            <Input
                                name='kilogram'
                                id='kilogram'
                                className='form-control'
                                placeholder='Ingrese una cantidad'
                                type='number'
                                validate={{ required: { value: true } }}
                                onChange={(e) => {
                                    validation.handleChange(e);
                                    setFirstChange(true);
                                }}
                                onBlur={validation.handleBlur}
                                value={validation.values.kilogram || ''}
                                invalid={
                                    validation.touched.kilogram &&
                                        validation.errors.kilogram
                                        ? true
                                        : false
                                }
                                disabled={isLoading}
                            />
                            {
                                validation.touched.kilogram &&
                                    validation.errors.kilogram ? (
                                    <FormFeedback type='invalid'>
                                        {validation.errors.kilogram}
                                    </FormFeedback>
                                ) : null
                            }
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default ConversionSection;